import React, {
  Component,
  useRef,
  useState,
  useEffect,
  useCallback,
} from "react";
import { Icon, Loader } from "semantic-ui-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { ValueList } from "./Component.js";

import swal from "sweetalert";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";
import {
  Container,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  LinkRedirect,
  SemanticButton,
  StatusToogleButton,
} from "./styled";

import { producaov2 as api } from "../../../../services/apis";
import { systemLogs } from "../../../../services/system_logs.js";

toast.configure();

const ListarDepoimento = (props) => {
  const [depoimentos, setDepoimentos] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuth();
    api
      .get(`admin/pessoa/depoimentos`)
      .then(async (res) => {
        await systemLogs("depoimento", "listou os depoimentos");

        setDepoimentos((depoimentos) => [...depoimentos, ...res.data]);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        swal("Não foi possível carregar os Depoimentos", err, "").then((res) =>
          props.history.push("/")
        );
      });
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const deletarDepoimento = useCallback(
    async (id) => {
      try {
        const res = await api.delete(`admin/pessoa/depoimentos/${id}`);
        await systemLogs("depoimento", `deletou o depoimento de id=${id}`);

        const newDepoimentos = [...depoimentos].filter(
          (depoimento) => depoimento.id !== id
        );
        setDepoimentos(newDepoimentos);
        swal(res.data.msg, "", "success");
      } catch (err) {
        swal("Erro ao excluir o curso", "Contate TI", "success");
      }
    },
    [depoimentos]
  );

  const valorTreinamento = (valor) => {
    if (valor.treinamento == null) {
      return "treinamento não salvo";
    } else {
      return valor.treinamento.nome;
    }
  };

  return (
    <>
      <AdminMenu />
      <Container>
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <>
            <Title>Depoimentos</Title>

            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Icon name="search icon" />
              <CreateButton to="/admindev/depoimentos/criar">
                Criar
              </CreateButton>
            </ContainerInputSearch>

            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell> Id </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell> Aluno </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell> Área </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>
                    {" "}
                    Treinamento{" "}
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell> Status </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell> Ações </SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>
              <SemanticTable.Body>
                {depoimentos
                  .filter((depoimento) =>
                    valorTreinamento(depoimento)
                      .toLowerCase()
                      .includes(search.toLowerCase())
                  )
                  .map((depoimento, index) => (
                    <ValueList
                      valor={depoimento}
                      deletarDepoimento={deletarDepoimento}
                    />
                  ))}
              </SemanticTable.Body>
            </SemanticTable>
          </>
        )}
      </Container>
    </>
  );
};

export default ListarDepoimento;
